module.exports = __webpack_public_path__ + "img/loginbanner1.7d6b07a4.jpg";